import React from 'react';
import Checkbox from '../../../app/common/components/Checkbox';
import { OptionalCheckbox } from '../sharedStyles';
import { TranslationHelpers } from '../../../i18n/translationHelpers';

export default ({ locale, serviceUuid, consent, updateOptionalConsentStatus }) => {
    return (
        <OptionalCheckbox key={serviceUuid} className="tst-nslt">
            <Checkbox
                id={serviceUuid}
                name={serviceUuid}
                key={serviceUuid}
                ariaLabel="Subscribed to the Newsletter"
                value={consent.granted}
                onChange={() => {
                    const { extraParameters } = consent;
                    updateOptionalConsentStatus(
                        {
                            extraParameters,
                            serviceUuid,
                        },
                        locale,
                    );
                }}
            />
            <p>
                {consent.title
                    ? consent.title
                    : TranslationHelpers.getFormattedMessage(consent.translationKey)}
            </p>
        </OptionalCheckbox>
    );
};
